<template>
  <div class="well page">
    <div class="row">
      <h2>Store Selection</h2>
      <div id="showMsg"><!-- Error messages etc are shown here --></div>
      <p>Select the appropriate store you would like to file an issue for.</p>
      <input type="search" v-model="search_query" class="form-control" placeholder="Filter Stores..."/>
      <br>
    </div>

    <div class="row" v-for="i in Math.ceil(stores.length / 3)">
      <div class="col-md-4" v-for="store in stores.slice((i - 1) * 3, i * 3)">
        <div class="panel panel-primary hvr-grow hvr-fix clickable" @click="select_store(store)">
          <div class="panel-heading">
            <h3 v-if="store.franchise_name" class="panel-title">{{ store.name }} - {{ store.franchise_name }}</h3>
            <h3 v-if="!store.franchise_name" class="panel-title">{{ store.name }}</h3>
          </div>
          <div class="panel-body">
            {{ store.address }} <br/>
            {{ store.state_name }}
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!stores.length">
      <strong class="text-danger">No stores found - try using the store address or suburb</strong>
    </div>
  </div>
</template>

<script>
  import filter from "lodash/filter"
  import includes from "lodash/includes"

  export default {
    created () {
      this.$store.dispatch("get_stores");
      this.$store.commit("select_store", -1);
    },
    data () {
      return {
        search_query: ""
      };
    },
    computed: {
      stores () {
        if (this.search_query.trim() !== "") {
          return this.filtered_stores;
        }
        return this.$store.state.stores;
      },
      filtered_stores () {
        return filter(this.$store.state.stores, store => {
          return includes(store.name.toLowerCase(), this.search_query.toLowerCase()) ||
                 includes(store.address.toLowerCase(), this.search_query.toLowerCase()) ||
                 includes(store.state_name.toLowerCase(), this.search_query.toLowerCase()) ||
                 (store.franchise_name && includes(store.franchise_name.toLowerCase(), this.search_query.toLowerCase()));
        });
      }
    },
    methods: {
      select_store (store) {
        this.$router.push({
          name: "store-jobs",
          params: { store_id: store.id }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/StoreList.vue?2cdc9e4b